export const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const SET_MATCH_ROUTES = 'SET_MATCH_ROUTES';
